// extracted by mini-css-extract-plugin
export default {"row":"planogram_row__XrxPr","placeHolderShimmer":"planogram_placeHolderShimmer__Ac0Ol"};